export default "__VITE_ASSET__DZfdkWML__"